import {
  AGENCY_LOADING,
  GET_AGENCY,
  GET_AGENCY_SUCCESS,
  GET_AGENCY_FAIL,
  ADD_AGENCY_SUCCESS,
  ADD_AGENCY_FAIL,
  DELETE_AGENCY_SUCCESS,
  DELETE_AGENCY_FAIL,
  UPDATE_AGENCY_SUCCESS,
  UPDATE_AGENCY_FAIL,
  AGENCY_RESET,
  AGENCY_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  agencys: [],
  agencyAdded: {},
  error: {},
};

const Agency = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_AGENCY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_AGENCY:
          return {
            ...state,
            agencys: action.payload.data,
            isAgencyCreated: false,
            isAgencySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_AGENCY_FAIL:
      switch (action.payload.actionType) {
        case GET_AGENCY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAgencyCreated: false,
            isAgencySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_AGENCY: {
      return {
        ...state,
        isAgencyCreated: false,
        loading: true,
      };
    }

    case AGENCY_LOADING: {
      return {
        ...state,
        isAgencyCreated: false,
        loading: true,
      };
    }

    case ADD_AGENCY_SUCCESS:
      return {
        ...state,
        isAgencyCreated: true,
        loading: false,
        agencys: [action.payload.data, ...state.agencys],
        agencyAdded: action.payload.data,
      };

    case ADD_AGENCY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_AGENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        agencys: state.agencys.filter(
          agency => agency.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_AGENCY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_AGENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        agencys: state.agencys.map(agency =>
          agency.id.toString() === action.payload.data.id.toString() ? { ...agency, ...action.payload.data } : agency
        ),
      };

    case UPDATE_AGENCY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case AGENCY_RESET_CREATE:
      return {
        ...state,
        isAgencyCreated: false,
      };

    case AGENCY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Agency;